import { legacy_createStore as createStore, combineReducers } from 'redux'
import { metaMaskReducer,blockchainContractReducer } from './reducer'



const rootReducer = combineReducers({ 
    metaMask: metaMaskReducer,
    blockchainContract: blockchainContractReducer,
    // employeeListReducer : employeeListReducer,
    // clientListReducer : clientListReducer,
    // personalFoldersReducer : personalFoldersReducer,
    // sharedFoldersReducer : sharedFoldersReducer,
    // favoriteFoldersReducer : favoriteFoldersReducer,
})
// export const store = createStore(searchReducer)
const store = createStore(rootReducer);

export default store;